export enum ExpertiseGradeEnum {

  midwife = 1,

  doctor = 2,

  expert = 3,

  specialty = 4,

  expertFllowship = 5,

  subspecialtyFellowship = 6
}
